import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIPowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import MUITextField from "@mui/material/TextField";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUIStack from "@mui/material/Stack";

export default class CardAdminQueueFilterOrderActivityFollowupDate extends CardClass {
  constructor(props) {
    super(props);

    this.state = {
      enabled: !!props.queue.filter?.["order_activity.follow_up_date"],
    };
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleChange = (key, value) => {
      const filter = this.props.queue.filter;

      filter["order_activity.follow_up_date"].properties[key] = value;

      this.props.onChange({
        filter: filter,
      });
    };

    const options = {
      operators: [
        {
          value: "<",
          label: "Followup Date is before",
        },
        {
          value: ">",
          label: "Followup Date is after",
        },
      ],
      units: [
        {
          value: "hour",
          label: "hours ago",
        },
        {
          value: "day",
          label: "days ago",
        },
        {
          value: "week",
          label: "weeks ago",
        },
        {
          value: "month",
          label: "months ago",
        },
        {
          value: "year",
          label: "years ago",
        },
      ],
    };

    if (this.state.enabled) {
      return (
        <MUIStack direction="row" spacing={1}>
          <MUIAutocomplete
            options={options.operators}
            getOptionLabel={(option) => option.label}
            value={
              options.operators.find(
                (operator) =>
                  operator.value ===
                  this.props.queue?.filter["order_activity.follow_up_date"]
                    .properties.operator,
              ) || null
            }
            onChange={(e, option) =>
              handleChange("operator", option?.value || null)
            }
            renderInput={(params) => {
              return (
                <MUITextField
                  {...params}
                  size="small"
                  label="Operator"
                  variant="standard"
                  required={true}
                  sx={{ width: 225 }}
                  error={
                    this.props.validationIssues.filter?.[
                      "order_activity.follow_up_date"
                    ]?.["operator"]
                      ? true
                      : false
                  }
                  helperText={
                    this.props.validationIssues.filter?.[
                      "order_activity.follow_up_date"
                    ]?.["operator"]
                      ? this.props.validationIssues.filter[
                          "order_activity.follow_up_date"
                        ]["operator"]
                      : ""
                  }
                  InputLabelProps={{ shrink: true }}
                />
              );
            }}
          />
          <MUITextField
            size="small"
            label="Value"
            variant="standard"
            required={true}
            sx={{ width: 50 }}
            value={
              this.props.queue.filter["order_activity.follow_up_date"]
                .properties.value
            }
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d+$/.test(value)) {
                handleChange("value", Number(value));
              } else {
                handleChange("value", "");
              }
            }}
            error={
              this.props.validationIssues.filter?.[
                "order_activity.follow_up_date"
              ]?.["value"]
                ? true
                : false
            }
            helperText={
              this.props.validationIssues.filter?.[
                "order_activity.follow_up_date"
              ]?.["value"]
                ? this.props.validationIssues.filter[
                    "order_activity.follow_up_date"
                  ]["value"]
                : ""
            }
            slotProps={{
              htmlInput: {
                maxLength: 3,
                inputMode: "numeric",
              },

              inputLabel: { shrink: true },
            }}
          />
          <MUIAutocomplete
            options={options.units}
            getOptionLabel={(option) => option.label}
            value={
              options.units.find(
                (unit) =>
                  unit.value ===
                  this.props.queue?.filter["order_activity.follow_up_date"]
                    .properties.unit,
              ) || null
            }
            onChange={(e, option) =>
              handleChange("unit", option?.value || null)
            }
            renderInput={(params) => {
              return (
                <MUITextField
                  {...params}
                  size="small"
                  label="Unit"
                  variant="standard"
                  required={true}
                  sx={{ width: 150 }}
                  error={
                    this.props.validationIssues.filter?.[
                      "order_activity.follow_up_date"
                    ]?.["unit"]
                      ? true
                      : false
                  }
                  helperText={
                    this.props.validationIssues.filter?.[
                      "order_activity.follow_up_date"
                    ]?.["unit"]
                      ? this.props.validationIssues.filter[
                          "order_activity.follow_up_date"
                        ]["unit"]
                      : ""
                  }
                  InputLabelProps={{ shrink: true }}
                />
              );
            }}
          />
        </MUIStack>
      );
    } else {
      return (
        <EmptyState line1="Not Enabled" line2="Showing all Followup Dates" />
      );
    }
  }

  /**
   * Renders add Term button
   */
  getActions() {
    const handleEnableDisable = () => {
      if (this.state.enabled) {
        const filter = this.props.queue.filter;
        delete filter["order_activity.follow_up_date"];

        // Disable and delete
        this.setState({
          enabled: false,
        });
      } else {
        // Enable and initialize
        const filter = this.props.queue.filter || {};
        filter["order_activity.follow_up_date"] = {
          type: "relativeDate",
          properties: {
            operator: null,
            value: "",
            unit: null,
          },
        };
        this.props.onChange({
          filter: filter,
        });

        this.setState({
          enabled: true,
        });
      }
    };

    const buttonItems = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIPowerSettingsNewIcon />}
        onClick={handleEnableDisable}
      >
        {this.state.enabled ? "Disable" : "Enable"}
      </MUIButton>,
    ];

    return buttonItems;
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filter: Order Activity > Followup Date";
  }
}
